import React from "react";
// project-import
import NoDataFoundNew from "./404ErrorNew";
import InternalServerError from "./500Error";

export default function ErrorComponent(props) {
    // Property initialization
    const {
        errorCode,
        showImg = true,
        subText = "No data found",
        mainError = "Oops... No Data Found!",
        buttonText = "Back to Home",
        showBtn = true,
        link = "/",
        onBtnClick = () => { }
    } = props;

    return (

        <div>
            {errorCode === "404" && (
                <>
                    {showImg ? (
                        <NoDataFoundNew showBtn={showBtn} mainError={mainError} subText={subText} buttonText={buttonText} link={link} onBtnClick={onBtnClick} />
                    ) : (
                        <p className="text-md pb-0 text-secondary">{subText}</p>
                    )}
                </>
            )}
            {errorCode === "500" && (
                <>
                    <InternalServerError />
                    {<h5 className="title text-secondary">{mainError}</h5>}
                    {props.subText && (
                        <div
                            className="text-md pb-0 text-secondary"
                            dangerouslySetInnerHTML={{ __html: props.subText }}
                        />
                    )}
                </>
            )}
        </div>
    );
}